import { TypePolicy } from '@apollo/client';

export const APOLLO_CLIENT_CACHE_POLICY_OPTIONS = {
  typePolicies: {
    Dimension: {
      keyFields: false,
    } as TypePolicy,
    App: {
      keyFields: ['id'],
      merge(existing, incoming, { mergeObjects }) {
        return mergeObjects(existing, incoming);
      },
    } as TypePolicy,
  },
};
